// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Viewers__container-f3f2ea {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  background-color: var(--addition-100);
  width: 360px;
}

.Viewers__header-e03d8c {
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  height: 72px;
  padding: 0 72px 0 16px;
  justify-content: center;
  align-items: flex-start;
}

.Viewers__title-d7b72b {
  color: var(--addition-50_70);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.Viewers__total-e26154 {
  color: var(--addition-50);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.Viewers__close-c11a2f {
  position: absolute;
  inset-inline-end: 16px;
  top: 16px;
}

.Viewers__list-e9beb2 {
  flex: 1;
  overflow-y: auto;
}

.Viewers__item-e377b6 {
  display: flex;
  overflow: hidden;
  flex: 1;
  padding: 8px 16px;
  align-items: center;
  color: var(--addition-50);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.Viewers__avatar-container-fb035f {
  position: relative;
}

.Viewers__muted-badge-cccabf {
  position: absolute;
  inset-inline-end: -6px;
  bottom: -4px;
}

.Viewers__name-b289e5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 2;
  margin-inline-start: 14px;
  margin-inline-end: 8px;
}

.Viewers__invite-f20f95 {
  display: none;
  margin-inline-start: auto;
}

.Viewers__item-e377b6:hover .Viewers__invite-f20f95 {
  display: flex;
}

.Viewers__tooltip-bb55f9 {
  background-color: var(--addition-110);
}

.Viewers__streamer-f8ca87 {
  margin-inline-start: auto;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-subtitle-4);
  color: var(--addition-50);
  opacity: 0.7;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
}

.Viewers__mute-d91525 {
  opacity: 0;
  margin-inline-start: 16px;
}

.Viewers__item-e377b6:hover .Viewers__mute-d91525 {
  opacity: 1;
}

.Viewers__item-e377b6:hover .Viewers__muted-b6231c {
  cursor: default;
  opacity: 0;
}

.Viewers__no-viewers-bc7c30 {
  margin-top: -36px;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.Viewers__description-f09d34 {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--addition-50);
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/InitiatorView/FullScreenView/Viewers/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,qCAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,4BAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,OAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,yBAAA;EACA,4BAAA;EACA,sCAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,OAAA;AACF;;AAEA;EACE,UAAA;EACA,yBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,eAAA;EACA,UAAA;AACF;;AAEA;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  background-color: var(--addition-100);\n  width: 360px;\n}\n\n.header {\n  position: relative;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  height: 72px;\n  padding: 0 72px 0 16px;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.title {\n  color: var(--addition-50_70);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.total {\n  color: var(--addition-50);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.close {\n  position: absolute;\n  inset-inline-end: 16px;\n  top: 16px;\n}\n\n.list {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.item {\n  display: flex;\n  overflow: hidden;\n  flex: 1;\n  padding: 8px 16px;\n  align-items: center;\n  color: var(--addition-50);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.avatar-container {\n  position: relative;\n}\n\n.muted-badge {\n  position: absolute;\n  inset-inline-end: -6px;\n  bottom: -4px;\n}\n\n.name {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  flex: 2;\n  margin-inline-start: 14px;\n  margin-inline-end: 8px;\n}\n\n.invite {\n  display: none;\n  margin-inline-start: auto;\n}\n\n.item:hover .invite {\n  display: flex;\n}\n\n.tooltip {\n  background-color: var(--addition-110);\n}\n\n.streamer {\n  margin-inline-start: auto;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-subtitle-4);\n  color: var(--addition-50);\n  opacity: 0.7;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  flex: 1;\n}\n\n.mute {\n  opacity: 0;\n  margin-inline-start: 16px;\n}\n\n.item:hover .mute {\n  opacity: 1;\n}\n\n.item:hover .muted {\n  cursor: default;\n  opacity: 0;\n}\n\n.no-viewers {\n  margin-top: -36px;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.description {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--addition-50);\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Viewers__container-f3f2ea`,
	"header": `Viewers__header-e03d8c`,
	"title": `Viewers__title-d7b72b`,
	"total": `Viewers__total-e26154`,
	"close": `Viewers__close-c11a2f`,
	"list": `Viewers__list-e9beb2`,
	"item": `Viewers__item-e377b6`,
	"avatar-container": `Viewers__avatar-container-fb035f`,
	"avatarContainer": `Viewers__avatar-container-fb035f`,
	"muted-badge": `Viewers__muted-badge-cccabf`,
	"mutedBadge": `Viewers__muted-badge-cccabf`,
	"name": `Viewers__name-b289e5`,
	"invite": `Viewers__invite-f20f95`,
	"tooltip": `Viewers__tooltip-bb55f9`,
	"streamer": `Viewers__streamer-f8ca87`,
	"mute": `Viewers__mute-d91525`,
	"muted": `Viewers__muted-b6231c`,
	"no-viewers": `Viewers__no-viewers-bc7c30`,
	"noViewers": `Viewers__no-viewers-bc7c30`,
	"description": `Viewers__description-f09d34`
};
module.exports = ___CSS_LOADER_EXPORT___;
